export enum QUERY_KEYS {
  getAdminUsers = 'get-admin-users',
}
